import { InvalidateQueryFilters, useQueryClient } from "@tanstack/react-query";
import has from "lodash/has";
import isEmpty from "lodash/isEmpty";
import isMatch from "lodash/isMatch";
import isPlainObject from "lodash/isPlainObject";

import { FetchEngagementsPayload } from "../../../services/engagements";
import { engagementsKeys } from "./query_keys";

const isFiltersQueryKey = (
  queryKeyPart: FetchEngagementsPayload | unknown[]
): queryKeyPart is FetchEngagementsPayload =>
  isPlainObject(queryKeyPart) &&
  ["page", "perPage", "filters", "order"].some((fetchEngagementsParamsProperty) =>
    has(queryKeyPart, fetchEngagementsParamsProperty)
  );

export const useEngagementsInvalidate = () => {
  const queryClient = useQueryClient();

  return {
    invalidateAll: () => {
      queryClient.invalidateQueries({ queryKey: engagementsKeys.all() });
    },
    invalidateFiltered: (
      filters: FetchEngagementsPayload | undefined,
      refetchType?: InvalidateQueryFilters["refetchType"]
    ) =>
      queryClient.invalidateQueries({
        refetchType,
        predicate: (query) => {
          if (query.queryKey[0] !== "engagements") {
            return false;
          }

          if (!filters || isEmpty(filters)) {
            return true;
          }

          const queriedFilters = query.queryKey.find(isFiltersQueryKey);

          return !!queriedFilters && isMatch(queriedFilters, filters);
        }
      })
  };
};
